<app-navbar [currentSection]="currentSection" />
<main>
<section class="relative overflow-hidden pt-40 after:content-[''] after:absolute after:inset-0 after:mx-auto after:size-[56rem] after:bg-gradient-to-tl after:to-cyan-100/60 after:from-orange-100/50 dark:after:to-cyan-600/30 dark:after:from-indigo-600/30 after:blur-[200px] after:rounded-full after:-z-1"
  id="home">
  <div class="container relative z-2">
    <div class="max-w-sm mx-auto bg-white dark:bg-slate-900 shadow-xl rounded-3xl p-8">

      <h4 class="text-2xl font-bold text-center mb-6">
        {{ (isRegister ? 'pages.login-page.register' : 'pages.login-page.login') | translate }}
      </h4>

      <!-- Google -->
      <button
        class="w-full flex items-center justify-center gap-3 border border-slate-200 dark:border-slate-700 rounded-xl py-2.5 mb-4 hover:bg-slate-50 dark:hover:bg-slate-800 transition"
        (click)="signInWithGoogle()" [disabled]="loading">
        <svg class="size-5" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.08 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-3.59-13.46-8.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
        {{ 'pages.login-page.signInWithGoogle' | translate }}
      </button>

      <div class="flex items-center gap-2 my-4">
        <hr class="flex-1 border-slate-200 dark:border-slate-700">
        <span class="text-slate-400 text-sm">{{ 'pages.login-page.orEmail' | translate }}</span>
        <hr class="flex-1 border-slate-200 dark:border-slate-700">
      </div>

      <!-- Email / Password -->
      <form (ngSubmit)="signInWithEmail()" class="flex flex-col gap-3">
        <input
          type="email" [(ngModel)]="email" name="email" required
          [placeholder]="'pages.login-page.email' | translate"
          [attr.aria-label]="'pages.login-page.email' | translate"
          class="w-full border border-slate-200 dark:border-slate-700 dark:bg-slate-800 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-cyan-500" />
        <input
          type="password" [(ngModel)]="password" name="password" required
          [placeholder]="'pages.login-page.password' | translate"
          [attr.aria-label]="'pages.login-page.password' | translate"
          class="w-full border border-slate-200 dark:border-slate-700 dark:bg-slate-800 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-cyan-500" />

        @if (!isRegister) {
          <p class="text-right text-sm">
            <a routerLink="/forgot-password" class="text-cyan-600 hover:underline">{{ 'pages.login-page.forgotPassword' | translate }}</a>
          </p>
        }

        @if (errorKey) {
          <p class="text-red-500 text-sm text-center">{{ errorKey | translate }}</p>
        }

        <button type="submit"
          class="w-full bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-xl py-2.5 transition"
          [disabled]="loading">
          @if (loading) {
            <div class="spinner spinner-sm inline-block"></div>
          } @else {
            {{ (isRegister ? 'pages.login-page.register' : 'pages.login-page.login') | translate }}
          }
        </button>
      </form>

      <p class="text-center text-sm text-slate-400 mt-4">
        @if (!isRegister) {
          {{ 'pages.login-page.noAccount' | translate }}
          <button class="text-cyan-600 hover:underline" (click)="isRegister = true">{{ 'pages.login-page.register' | translate }}</button>
        } @else {
          {{ 'pages.login-page.haveAccount' | translate }}
          <button class="text-cyan-600 hover:underline" (click)="isRegister = false">{{ 'pages.login-page.login' | translate }}</button>
        }
      </p>

    </div>
  </div>
</section>
</main>
<app-footer />
